import React from "react";

const Header = () => {
  return (
    <div>
      <h1 className="heading">
        IOT <br /> Fridge sensor
      </h1>
    </div>
  );
};

export default Header;
